import * as api from "~/api";
import { CONTACT } from "~/utils/urlApi";

export const apiPostContact = (baseUrl, data) => {
  return api.postHttpRequestAsync(`${baseUrl}${CONTACT.POST_URL}`, data);
};
